import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Dropdown, Container, Row, Col, Form } from "react-bootstrap";
import { RouterStateButton } from '../forms/elements';
import { PageCounter } from "../article/PageCounter";
import moment from "moment";
import DatePicker from "react-datepicker";
import { FiFilter } from "react-icons/fi";
import { Loading } from '../state';
import { useHistory } from 'react-router-dom';

var OfflineOrders = function OfflineOrders(props) {
  var _props$getOfflineOrde = props.getOfflineOrders,
      getOfflineOrders = _props$getOfflineOrde === void 0 ? function () {
    return console.log("getOfflineOrders");
  } : _props$getOfflineOrde,
      _props$offlineOrders = props.offlineOrders,
      offlineOrders = _props$offlineOrders === void 0 ? [] : _props$offlineOrders,
      totalCount = props.totalCount,
      pageSize = props.pageSize,
      startIndex = props.startIndex,
      _props$title = props.title,
      title = _props$title === void 0 ? "title" : _props$title,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false.length : _props$loading,
      _props$setSelectedOrd = props.setSelectedOrder,
      setSelectedOrder = _props$setSelectedOrd === void 0 ? function () {
    return "";
  } : _props$setSelectedOrd;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFilterPopUpOpen = _useState6[0],
      setFilterPopUp = _useState6[1];

  var _useState7 = useState('50'),
      _useState8 = _slicedToArray(_useState7, 2),
      itemsPerPage = _useState8[0],
      setItemsPerPage = _useState8[1];

  var _useState9 = useState('All'),
      _useState10 = _slicedToArray(_useState9, 2),
      orderStatusFilter = _useState10[0],
      setOrderStatusFilter = _useState10[1];

  var filterBtnClass = startDate && endDate || !startDate && !endDate ? "cb-button-primary offline-table" : "cb-button-primary offline-table filter-disabled";

  var _useState11 = useState('asc'),
      _useState12 = _slicedToArray(_useState11, 2),
      orderSort = _useState12[0],
      setOrderSort = _useState12[1];

  var _useState13 = useState('asc'),
      _useState14 = _slicedToArray(_useState13, 2),
      dateSort = _useState14[0],
      setDateSort = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      searchText = _useState16[0],
      setSearchText = _useState16[1];

  var history = useHistory();
  useEffect(function () {
    getOfflineOrders('0', orderStatusFilter, itemsPerPage, dateSort, 'datecreated', searchText);
  }, []);

  var pageChangeWrapper = function pageChangeWrapper(e) {
    var startDateUpdated = moment(startDate).format("MMDDYYYY");
    var endDateUpdated = moment(endDate).format("MMDDYYYY");
    var sortType = 'asc';
    var sortColumn = 'datecreated';

    if (orderSort === 'desc') {
      sortColumn = 'orderconfirmationid';
      sortType = 'desc';
    }

    if (dateSort === 'desc') {
      sortColumn = 'datecreated';
      sortType = 'desc';
    }

    getOfflineOrders(e, orderStatusFilter, itemsPerPage, sortType, sortColumn, searchText, startDateUpdated, endDateUpdated);
  };

  var handleStartDate = function handleStartDate(e) {
    try {
      if (e == null) {
        setFieldValue(title + "Date", undefined);
        setStartDate("");
      } else {
        var v = moment(e).format("YYYY-MM-DD");
        setFieldValue(title + "Date", v);
        setStartDate(e);
      }
    } catch (error) {
      console.log("handle date", error);
    }
  };

  var onHide = function onHide() {
    setFilterPopUp(false);
  };

  var handleEndDate = function handleEndDate(e) {
    try {
      if (e == null) {
        setFieldValue(title + "Date", undefined);
        setEndDate("");
      } else {
        var v = moment(e).format("YYYY-MM-DD");
        setFieldValue(title + "Date", v);
        setEndDate(e);
      }
    } catch (error) {
      console.log("handle date", error);
    }
  };

  var filterOrders = function filterOrders() {
    var startDateUpdated = moment(startDate).format("MMDDYYYY");
    var endDateUpdated = moment(endDate).format("MMDDYYYY");
    setOrderSort('asc');
    getOfflineOrders('0', orderStatusFilter, itemsPerPage, dateSort, 'datecreated', searchText, startDateUpdated, endDateUpdated);
    setFilterPopUp(false);
  };

  var resetFilter = function resetFilter() {
    setStartDate(null);
    setEndDate(null);
    setItemsPerPage('50');
    setOrderStatusFilter('All');
    setFilterPopUp(false);
    setSearchText('');
    setOrderSort('asc');
    getOfflineOrders('0', 'All', '50', dateSort, 'datecreated', '');
  };

  var handleFilterPopUp = function handleFilterPopUp() {
    setFilterPopUp(true);
  };

  var ItemsOptionsPerPage = [{
    id: 50,
    value: '50'
  }, {
    id: 100,
    value: '100'
  }, {
    id: 150,
    value: '150'
  }, {
    id: 200,
    value: '200'
  }];
  var orderStatusOptions = [{
    id: 1,
    value: 'Pending'
  }, {
    id: 2,
    value: 'Completed'
  }, {
    id: 3,
    value: 'Problem'
  }, {
    id: 4,
    value: 'All'
  }];

  var onSelectItemNumbers = function onSelectItemNumbers(eventkey) {
    setItemsPerPage(eventkey);
  };

  var onSelectOrderStatus = function onSelectOrderStatus(eventkey) {
    setOrderStatusFilter(eventkey);
  };

  var sortOrder = function sortOrder() {
    var updatedOrder = orderSort === 'asc' ? 'desc' : 'asc';
    setOrderSort(updatedOrder);
    var startDateUpdated = moment(startDate).format("MMDDYYYY");
    var endDateUpdated = moment(endDate).format("MMDDYYYY");
    setDateSort('asc');
    getOfflineOrders(startIndex, orderStatusFilter, itemsPerPage, updatedOrder, 'orderconfirmationid', searchText, startDateUpdated, endDateUpdated);
  };

  var orderTermUpdate = function orderTermUpdate(e) {
    setSearchText(e.target.value);
  };

  var sortDate = function sortDate() {
    var updatedDate = dateSort === 'asc' ? 'desc' : 'asc';
    setDateSort(updatedDate);
    var startDateUpdated = moment(startDate).format("MMDDYYYY");
    var endDateUpdated = moment(endDate).format("MMDDYYYY");
    setOrderSort('asc');
    getOfflineOrders(startIndex, orderStatusFilter, itemsPerPage, updatedDate, 'datecreated', searchText, startDateUpdated, endDateUpdated);
  };

  var selectOrder = function selectOrder(order) {
    setSelectedOrder(order);
    history.push('/shop/orders/details');
  };

  var FilterComponent = function FilterComponent() {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Order Term"), /*#__PURE__*/React.createElement(Form.Control, {
      autoFocus: true,
      className: "offline_search",
      type: "text",
      value: searchText,
      onChange: orderTermUpdate,
      placeholder: "Enter order number or email"
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "filter-row"
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Start Date"), /*#__PURE__*/React.createElement(DatePicker, {
      selected: startDate,
      onChange: handleStartDate,
      id: "dateSelectorStart",
      placeholderText: "Select Start Date",
      todayButton: "Today",
      className: "cb-form__input form-control datepicker-box",
      maxDate: endDate || new Date(),
      popperClassName: "datePicker-position"
    })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "End Date"), /*#__PURE__*/React.createElement(DatePicker, {
      selected: endDate,
      onChange: handleEndDate,
      id: "dateSelectorEnd",
      placeholderText: "Select End Date",
      todayButton: "Today",
      className: "cb-form__input form-control datepicker-box",
      minDate: startDate,
      maxDate: new Date(),
      popperClassName: "datePicker-position"
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "filter-row"
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Orders per page"), /*#__PURE__*/React.createElement(Dropdown, {
      onSelect: onSelectItemNumbers
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      className: "filter-dropdown"
    }, itemsPerPage), /*#__PURE__*/React.createElement(Dropdown.Menu, null, ItemsOptionsPerPage.map(function (item) {
      return /*#__PURE__*/React.createElement(Dropdown.Item, {
        className: "filter-row",
        eventKey: item.value
      }, item.value);
    })))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Order Status"), /*#__PURE__*/React.createElement(Dropdown, {
      onSelect: onSelectOrderStatus
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      className: "filter-dropdown"
    }, orderStatusFilter), /*#__PURE__*/React.createElement(Dropdown.Menu, null, orderStatusOptions.map(function (status) {
      return /*#__PURE__*/React.createElement(Dropdown.Item, {
        className: "filter-row",
        eventKey: status.value
      }, status.value);
    }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-secondary offline-table",
      onClick: resetFilter
    }, "Reset"), /*#__PURE__*/React.createElement(Button, {
      className: filterBtnClass,
      onClick: filterOrders
    }, "Apply"))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "offline_container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offline_createOrder"
  }, /*#__PURE__*/React.createElement(RouterStateButton, {
    href: "/shop/orders/create",
    className: "cb-button-primary"
  }, "Create Order")), /*#__PURE__*/React.createElement(Row, {
    className: "filter-position"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handleFilterPopUp
  }, /*#__PURE__*/React.createElement(FiFilter, {
    className: "filter-icon"
  }), /*#__PURE__*/React.createElement("label", null, "Filters"))), /*#__PURE__*/React.createElement(Modal, {
    className: "cb-menu-secondary",
    show: isFilterPopUpOpen
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("label", null, "Filters"), /*#__PURE__*/React.createElement("button", {
    className: "button cb-modal__close",
    onClick: onHide
  }, "x")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(FilterComponent, null))), loading ? /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: loading
  })) : offlineOrders && offlineOrders.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    hover: true
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Order Number", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cb-button-unstyled cb-accordion__toggle ".concat(orderSort === 'desc' ? 'is-active' : '', " sorting-key"),
    onClick: sortOrder
  })), /*#__PURE__*/React.createElement("th", null, "Submitted Date", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cb-button-unstyled cb-accordion__toggle ".concat(dateSort === 'desc' ? 'is-active' : '', " sorting-key"),
    onClick: sortDate
  })), /*#__PURE__*/React.createElement("th", null, "Customer Name"), /*#__PURE__*/React.createElement("th", null, "Customer Email"), /*#__PURE__*/React.createElement("th", null, "Customer Phone"), /*#__PURE__*/React.createElement("th", null, "Order Total"), /*#__PURE__*/React.createElement("th", null, "Order Status"))), /*#__PURE__*/React.createElement("tbody", null, offlineOrders.map(function (item) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        selectOrder(item);
      }
    }, item.orderNumber)), /*#__PURE__*/React.createElement("td", null, moment(item.submittedDate).format("YYYY-MM-DD HH:mm:ss")), /*#__PURE__*/React.createElement("td", null, item.fulfillmentInfo.fulfillmentContact.firstName, " ", item.fulfillmentInfo.fulfillmentContact.lastNameOrSurname), /*#__PURE__*/React.createElement("td", null, item.fulfillmentInfo.fulfillmentContact.email), /*#__PURE__*/React.createElement("td", null, item.fulfillmentInfo.fulfillmentContact.phoneNumbers.home), /*#__PURE__*/React.createElement("td", null, item.total), /*#__PURE__*/React.createElement("td", null, item.status));
  }))), /*#__PURE__*/React.createElement("h3", {
    className: "h-100 cb-location-finder__no-locations"
  }, "Showing ", startIndex * pageSize + 1, " - ", startIndex * pageSize + offlineOrders.length, " of ", totalCount, " records"), /*#__PURE__*/React.createElement(PageCounter, {
    totalPages: Math.ceil(totalCount / pageSize),
    handleChange: pageChangeWrapper,
    currentPage: startIndex
  })) : /*#__PURE__*/React.createElement("h2", {
    className: "h-100 cb-location-finder__no-locations"
  }, "No Results to display"));
};

export default OfflineOrders;